module.exports = __webpack_public_path__ + "img/border_oblique_corner.b36f6217.svg";